import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import {
  AvailabilitySlotTypeProvider,
  IconLibrary,
  PageSection,
  StackablePageButtons,
} from '@product-framework/index';
import { FORM_ACTION } from '@ui-framework/index';
import {
  useServiceProvider,
  withServiceProvider,
} from '../../../../../../providers/ServiceProviderProvider';
import ServiceProviderLayout from '../../../../components/ServiceProviderLayout';
import getSPLevelStackableButtons from '../../../../utils/getSPLevelStackableButtons';
import DefaultSchedules from '../../../../components/Availability/DefaultSchedules';

function DefaultSchedulesPage({ mode = FORM_ACTION.LIST }) {
  const { serviceProviderId, locationId } = useServiceProvider();
  const navigate = useNavigate();
  const stackablePageButtons = [
    ...([FORM_ACTION.EDIT, FORM_ACTION.LIST, FORM_ACTION.VIEW].includes(mode)
      ? [
          {
            label: (
              <FormattedMessage
                id="CREATE_DEFAULT_SCHEDULE"
                defaultMessage="Create Default Schedule"
              />
            ),
            id: 'CREATE_DEFAULT_SCHEDULE',
            Icon: IconLibrary.DefaultSchedule,
            variant: 'contained',
            permissionName: 'CAN_CREATE_SP_AVAILABILITY_DEFAULT_SCHEDULE',
            onClick: () => {
              navigate(
                `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/availability/default-schedules/create`,
              );
            },
          },
        ]
      : []),
    ...([FORM_ACTION.EDIT, FORM_ACTION.CREATE, FORM_ACTION.VIEW].includes(mode)
      ? [
          {
            label: (
              <FormattedMessage
                id="LIST_DEFAULT_SCHEDULES"
                defaultMessage="List Default Schedules"
              />
            ),
            id: 'LIST_DEFAULT_SCHEDULES',
            Icon: IconLibrary.DefaultSchedules,
            variant: 'outlined',
            permissionName: 'CAN_VIEW_SP_AVAILABILITY_DEFAULT_SCHEDULE',
            onClick: () => {
              navigate(
                `/serviceproviders/edit/${serviceProviderId}/locations/${locationId}/availability/default-schedules`,
              );
            },
          },
        ]
      : []),
  ];

  return (
    <ServiceProviderLayout
      selectedStepperId="LOCATION_AVAILABILITY_DEFAULT_SCHEDULES"
      stackablePageButtons={getSPLevelStackableButtons({
        navigate,
      })}>
      <PageSection
        label={
          <FormattedMessage
            id="SERVICE_PROVIDER_LOCATION_AVAILABILITY_DEFAULT_SCHEDULES"
            defaultMessage="Service Provider Location Availability - Default Schedules"
          />
        }
        HeaderContent={
          <StackablePageButtons
            backButton={false}
            buttons={stackablePageButtons}
          />
        }>
        <AvailabilitySlotTypeProvider>
          <DefaultSchedules
            serviceProviderId={serviceProviderId}
            mode={mode}
            locationId={locationId}
          />
        </AvailabilitySlotTypeProvider>
      </PageSection>
    </ServiceProviderLayout>
  );
}

const DefaultSchedulesPageObserver = observer(DefaultSchedulesPage);
export default withServiceProvider(DefaultSchedulesPageObserver);
